export const COLOR_TO_SEND = 'secondary';
export const COLOR_SENT = 'accent';
export const COLOR_ACCOUNTED = 'warning';
export const COLOR_UNACCOUNTED = 'default';